import { IconButton, Stack } from '@mui/material';
import { IconType, MdClose, MdInfo, MdWarning } from '@teamworksdev/icons';
import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

const typeProps: Record<
  'warning' | 'info',
  { bg: string; icon: IconType; iconColor: string }
> = {
  warning: { bg: '#fef4e6', icon: MdWarning, iconColor: '#ef6820' },
  info: { bg: '#e6efff', icon: MdInfo, iconColor: '#2f5dff' },
};

export interface FormNotificationProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  type: keyof typeof typeProps;
  children: React.ReactNode;
  /** When provided, renders a dismiss button that invokes this callback. */
  onDismiss?: () => void;
}

export function FormNotification({
  title,
  type,
  children,
  className,
  onDismiss,
}: FormNotificationProps) {
  const { t } = useTranslation();
  const props = typeProps[type];
  const IconPath = props.icon;

  return (
    <div
      className={`p-4 rounded-md ${className}`}
      style={{
        backgroundColor: props.bg,
      }}
    >
      <Stack direction="row" alignItems="center" className="mb-2">
        <IconPath
          size={18}
          className="mr-2 text-gray-500"
          style={{ color: props.iconColor }}
        />
        <span className="font-bold">{title}</span>
        {onDismiss && (
          <IconButton
            size="small"
            aria-label={t('close')}
            onClick={onDismiss}
            className="ml-auto"
          >
            <MdClose size={18} />
          </IconButton>
        )}
      </Stack>
      {/* div, not p: some consumers pass block-level content (div/ul), which
          is invalid HTML nesting inside a p */}
      <div className="ml-6">{children}</div>
    </div>
  );
}
